module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./RoleForm.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/components/RoleForm.js
// module id = 1999
// module chunks = 4